import React, { useContext, useEffect, useState } from 'react';
import { AuthenticatedTemplate, useMsal } from "@azure/msal-react";
import { Link, NavLink, useNavigate } from "react-router-dom";
import { IIdTokenClaims } from '../util/DataModelInterface';
import { FormattedMessage, useIntl } from 'react-intl';
import { IntlContext } from "../util/IntlHelper";
import * as storage from '../util/StorageUtil';
import logo from "../assets/img/serty_logo.png";
import 'font-awesome/css/font-awesome.min.css';
import { getUser } from '../api/User';
import { makeLogEvent } from '../api/EventLog';
import { SignButton } from './SignButton';
import { Breadcrumbs } from './Breadcrumbs';
import { Button } from 'react-bootstrap';
import { Spinner } from '../components/Spinner';

interface INavigationBarProps {
  onUserLoad: () => void;
}

export const NavigationBar = (props: INavigationBarProps) => {
    const { instance } = useMsal();
    const intl = useIntl();
    const [name, setName] = useState("");
    const { locale, switchToEnglish, switchToSwedish, switchToFinnish } = useContext(IntlContext);
    const [shouldRedirectError, setShouldRedirectError] = useState(false);
    const navigate = useNavigate();
    const [isActive, setIsActive] = useState(false);
    const [loading, setLoading] = useState(false);
    console.log("locale:", locale);

    const handleResponsiveLangMenu = (eventKey : any) => {
      setIsActive(current => !current);
    }

    const currentAccount = instance.getActiveAccount();

    //console.log("NavBar - currectAccount", currentAccount);

    useEffect(() => {
      if (shouldRedirectError) navigate("/error", { replace: true, state: { title: "error.noUser", msg: "error.noUser.info" } });
    }, [navigate, shouldRedirectError]);

    useEffect(() => {
      if (shouldRedirectError) {
        return;
      }
      // Using async funtion inside effect for async fetch (https://www.robinwieruch.de/react-hooks-fetch-data/)
        const onLoad = async () => {
          setLoading(true);
          try {
            // Fetching only after login...
            if (currentAccount) {
              const email = (currentAccount.idTokenClaims as IIdTokenClaims)['email'];
              //console.log(email);
              const roles = (currentAccount.idTokenClaims as IIdTokenClaims)['roles'] || [];
              //console.log(roles);
              // -> AD:hen määritelty role menee jo tokenin mukana
              const userData = storage.getUser();
              if (!userData) {
                //console.log("NavBar - fetching user");
                const user  = await getUser(0, email);
                if (!user || user.error) {
                  setShouldRedirectError(true);
                  setLoading(false);
                  return;
                }
                setName(user.name || "");
                props.onUserLoad();
                await makeLogEvent(`User ${user.name} logged in`, "login", `Role ${roles[0]}`);
              } else {
                //console.log("NavBar - user fetched");
                setName(userData.name || "");
                props.onUserLoad();
              }
            }
          }  catch (error) {
            console.log(error);
          }
          setLoading(false);
        };
        onLoad();
    }, [currentAccount, props, shouldRedirectError]);

    let langText = locale==="fi-FI" ? intl.formatMessage({ id: 'language.finnish' }) :
                   ( locale==="sv-SE" ? intl.formatMessage({ id: 'language.swedish' }) : intl.formatMessage({ id: 'language.english' }) );

    return (
      <>
      <Spinner active={loading} />
      <div className="app-header d-flex flex-row">
        <div className="serty-id">
          <img src={logo} alt="Serty-logo"/>
        </div>
        <div className="d-flex flex-column flex-fill">
          <div className="d-flex flex-row align-items-md-end align-items-center flex-fill">
            <div className="site-id">
              <h1>
                <span>Numerus</span>
                <Link to="/home">
                  nova
                </Link>
              </h1>
            </div>
            <div className="user-details d-flex flex-md-row flex-column align-items-md-center ms-auto mb-0">
              <div className="d-flex flex-row details-wrp justify-content-end">
                <div className="menu-language me-xl-5 me-4">
                  <i role="presentation" className="fa fa-globe"></i>
                  <Button variant="link" className="navbar-toggler collapsed" onClick={handleResponsiveLangMenu}
                  aria-controls="langnav" aria-expanded="false" aria-label={ intl.formatMessage({ id: 'language.menu.toggle' })}>
                    <span>{langText}</span>
                  </Button>
                  <nav id="langnav" aria-label={ intl.formatMessage({ id: 'language.menu' })} className={isActive ? 'language-nav show ' : 'language-nav'}>
                    <button
                    onClick={switchToFinnish}
                    className={"btn btn-link" + (locale==="fi-FI" ? " active" : "") }
                    lang="fi">
                        Suomi
                    </button>
                    <button
                    onClick={switchToSwedish}
                    className={"btn btn-link" + (locale==="sv-SE" ? " active" : "") }
                    lang="sv">
                      Svenska
                    </button>
                    <button
                    onClick={switchToEnglish}
                    className={"btn btn-link" + (locale==="en-GB" ? " active" : "") }
                    lang="en">
                      English
                    </button>
                  </nav>

                </div>
              <AuthenticatedTemplate>
                <div className="loggedin-user">
                  <span className="sr-only sr-only-focusable"><FormattedMessage id="login.loggedinuser" /></span>
                    <span className="fa fa-user" role="presentation"></span>
                  <NavLink className="username" to="/profile">
                    {name}
                  </NavLink>
                </div>
              </AuthenticatedTemplate>
              </div>
              <SignButton/>
            </div>
          </div>
          <Breadcrumbs/>
        </div>
      </div>
      </>
    );
};
